<template>
  <div class="relative inline-block group">
    <InformationCircleIcon class="h-5 w-5 cursor-pointer text-gray-400 hover:text-gray-600 transition-colors" />

    <!-- Balão tooltip -->
    <div class="absolute left-6 top-4 -translate-y-1/2 z-80 hidden group-hover:block w-56 pointer-events-none">
      <!-- Seta -->
      <div class="absolute -left-1.5 top-1/2 -translate-y-1/2 w-3 h-3 bg-white border-l border-b border-gray-200 rotate-45 shadow-[-2px_2px_3px_rgba(0,0,0,0.05)]"></div>

      <!-- Card -->
      <div class="bg-white border border-gray-200 rounded-xl shadow-lg px-4 py-3">
        <p class="font-semibold text-gray-800 text-sm mb-1">{{ title }}</p>
        <p class="text-gray-500 text-xs leading-relaxed">{{ text }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { InformationCircleIcon } from "@heroicons/vue/16/solid";

defineProps<{
  title: string
  text: string
}>()
</script>

<style scoped>

</style>